export default __webpack_public_path__ + "static/media/team.69d5ea62.svg";